export default 'RECORDING_PROGRESS_UPDATED';
